import AnimatedCursor from "react-animated-cursor";
import "./App.scss";
import Router from "./Routes/Router";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Make sure the CSS is imported globally
import Chat from "./Chat";
import useFetch, {baseUrl} from "./hooks/useFetch";
import {useDispatch} from "react-redux";
import {fetchChallenges} from "./Redux/ChallengeDataSlice";
import {useEffect} from "react";

function App() {
  // remove all console logs
  // console.log = function () {};

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchChallenges());
  }, []);

  return (
    <div className="App">
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeButton={true}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
      <Chat />
    </div>
  );
}

export default App;
